import { ReactNode } from 'react'

export default function CourseEditorSkeleton(): ReactNode {
  return (
    <div className="flex w-full animate-pulse flex-col gap-5 overflow-hidden bg-background-secondary">
      <div className="h-8 w-64 rounded-xs bg-skeleton-primary" />
      {Array.from({ length: 7 }).map((_, i) => (
        <div key={i} className="grid grid-cols-[2.5rem_1fr] grid-rows-[2rem_1fr] gap-2">
          <div className="col-span-2 h-8 w-48 rounded-xs bg-skeleton-primary" />
          <div className="size-8 rounded-full bg-skeleton-primary" />
          <div className="h-8 w-48 rounded-xs bg-skeleton-primary" />
        </div>
      ))}
      <div className="h-10 w-64 self-center rounded-xs bg-skeleton-primary" />
    </div>
  )
}
